






























































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { mapState } from 'vuex'
import BeaconModel from '@/_models/BeaconModel'

@Component({
  components: {},
  computed: {},
})
export default class SearchBeacon extends Vue {
  // Props
  @Prop()
  selectedData!: any

  @Prop()
  beaconType!: string
  // data
  currentPage: number = 1
  perPage: number = 10
  numofPage: number = 1
  isFormModalActive: boolean = false
  searchQuery: string = ''
  selectedFilter: string = '_id'
  selected: any = { _id: '', major: '', minor: '' }

  filedNameLUT: any = {
    _id: 'UUID',
    major: 'label.major',
    minor: 'label.minor',
    category_name: 'label.category_name',
  }

  // computed
  get beacons(): BeaconModel[] {
    const beacons = this.$store.state.beacons.all.items
    this.numofPage = Math.ceil(beacons.length / this.perPage)

    return beacons
  }

  get isLoading(): boolean {
    return this.$store.state.beacons.loading
  }

  get filteredData(): BeaconModel[] {
    const targetField: string = this.selectedFilter
    if (!this.beacons) {
      return []
    }

    return this.beacons.filter((item: any): boolean => {
      return (
        String(item[targetField])
          .toLowerCase()
          .indexOf(this.searchQuery.toLowerCase()) !== -1
      )
    })
  }

  get disabledSelectRow(): any {
    return (row): boolean => {
      return row.user_id !== '' && row._id !== this.selectedData._id
    }
  }

  @Watch('selected')
  async selectedChanged() {
    if (!this.selected._id) {
      return
    }

    if (this.disabledSelectRow(this.selected)) {
      this.resetSelected()
    }
  }

  convertFieldName(value: string): string | null {
    if (!value) {
      return null
    }
    return this.$t(this.filedNameLUT[value]) as string
  }

  handleSelectFinished(): void {
    const selectedData = {
      _id: this.selected._id || '',
      major: this.selected.major || '',
      minor: this.selected.minor || '',
    }

    this.$emit('handleSelectedBeaconDone', selectedData)
  }

  resetSelected(): void {
    this.selected = {}
  }

  handleToggleSelected(): void {
    if (this.selected._id) {
      this.resetSelected()
    }
  }

  // After page created
  created() {
    const beaconType = this.beaconType || 'all'
    this.$store
      .dispatch('beacons/getAll', { beacon_type: this.beaconType })
      .then(() => {
        for (const item of this.filteredData) {
          if (
            typeof this.selectedData !== 'undefined' &&
            this.selectedData &&
            item._id === this.selectedData._id
          ) {
            this.selected = item
            return
          }
        }
      })
  }
}
